import * as actionTypes from './actionTypes';
import { setMessages } from './actionNotifications';
import firebase from '../../firebase';

const userFound = (user) => {
    return {
        type: actionTypes.USER_FOUND,
        user: user
    }
}

const userNotFound = () => {
    return dispatch => {
        dispatch({ type: actionTypes.USER_NOT_FOUND });
        dispatch(setMessages('User Not Found', 'error'));
    }
}

export const findUserByEmail = (email) => {
    return dispatch => {
        const db = firebase.firestore();
        db.collection('Users').get()
            .then(users => {
                let found = false;
                users.forEach(user => {
                    if (user.data().email === email && !found) {
                        dispatch(userFound(user.data()));
                        found = true;
                    }
                })
                if (!found) {
                    dispatch(userNotFound());
                }
            })
    }
};

const checkedIn = () => {
    return dispatch => {
        dispatch({ type: actionTypes.CHECKED_IN });
        dispatch(setMessages('Successfully Checked In', 'success'));
    }
}

export const checkInUser = (userData, email) => {
    const key = email.split('.').join('');
    return dispatch => {
        const db = firebase.firestore();
        db.collection('CheckedIn').doc(key).set(userData)
            .then(() => {
                dispatch(checkedIn());
            })
    }
};

const checkedOut = () => {
    return dispatch => {
        dispatch({ type: actionTypes.CHECKOUT_OUT });
        dispatch(setMessages('Successfully Checkout Out', 'success'));
    }
}

export const checkOutUser = (email) => {
    const key = email.split('.').join('');
    return dispatch => {
        const db = firebase.firestore();
        db.collection('CheckedIn').doc(key).get()
            .then((resp) => {
                const user = resp.data();
                const checkedInTime = user.checkIn.toDate();
                const checkedOutTime = new Date();
                const minutes = ((checkedOutTime.getTime() - checkedInTime.getTime()) / 1000) / 60;
                const userData = {
                    gender: user.gender,
                    group: user.group,
                    organization: user.organization,
                    reason: user.reason,
                    minutes: Math.round(minutes),
                    date: new Date().toDateString()
                };
                db.collection('TrackingData').add(userData)
                    .then(() => {
                        db.collection('CheckedIn').doc(key).delete()
                            .then(() => {
                                dispatch(checkedOut())
                            });
                    });
            }).catch(err => {
                dispatch(setMessages(email + ' Not Checked In', 'error'))
            });
    }
}

const listCheckedInUsers = (list) => {
    return {
        type: actionTypes.LIST_CHECKED_IN_USERS,
        list: list
    }
}

export const getCheckedInUsers = () => {
    return dispatch => {
        const db = firebase.firestore();
        db.collection('CheckedIn').get()
            .then(users => {
                const checkedInList = [];
                users.forEach(user => {
                    checkedInList.push(user.id);
                })
                dispatch(listCheckedInUsers(checkedInList));
            })
    }
}

const k12GroupCheckedIn = () => {
    return dispatch => {
        dispatch({ type: actionTypes.K12GROUP_CHECKED_IN });
        dispatch(setMessages('K12 Group Checked In', 'success'));
    }
}

export const checkInK12Group = (groupData) => {
    return dispatch => {
        const db = firebase.firestore();
        db.collection('K12Group').add(groupData)
            .then(() => {
                dispatch(k12GroupCheckedIn());
            });
    }
}

//CSV DATA
const CSVDataLoaded = (trackingData, k12Data) => {
    return {
        type: actionTypes.CSV_DATA_LOADED,
        trackingData: trackingData,
        k12Data: k12Data
    };
};

const unloadCSV = () => {
    return {
        type: actionTypes.CSV_DATA_UNLOADED
    };
};

export const loadCSVData = () => {
    return dispatch => {
        const db = firebase.firestore();
        db.collection('TrackingData').get()
            .then(resp => {
                const trackingData = [];
                resp.forEach(item => {
                    trackingData.push(item.data());
                });
                db.collection('K12Group').get()
                    .then(resp => {
                        const k12Data = [];
                        resp.forEach(item => {
                            k12Data.push(item.data());
                        });
                        dispatch(CSVDataLoaded(trackingData, k12Data));
                        setTimeout(() => {
                            dispatch(unloadCSV());
                        }, 3000);
                    }).catch(err => {
                        dispatch(setMessages('Error Downloading Data', 'error'));
                    });

            }).catch(err => {
                dispatch(setMessages('Error Downloading Data', 'error'));
            });
    };
};

const CSVDataDeleted = () => {
    return {
        type: actionTypes.CSV_DATA_DELETED
    }
}

export const deleteCSVData = () => {
    return dispatch => {
        const db = firebase.firestore();
        const batch = db.batch();
        db.collection('TrackingData').get()
            .then((resp) => {
                resp.forEach(item => {
                    batch.delete(item.ref);
                });
                db.collection('K12Group').get()
                    .then(k12Resp => {
                        k12Resp.forEach(item => {
                            batch.delete(item.ref);
                        })
                        batch.commit().then(() => {
                            dispatch(setMessages('Successfully Deleted Data', 'success'));
                            dispatch(CSVDataDeleted());
                        });

                    })

            }).catch(err => {
                dispatch(setMessages('Error Deleting Data', 'error'));
                console.log(err);
            })
    }
}